import $api from '../services';

export default {
    createGoals(id, params) {
        return $api.post(`/business/${id}/goals`, params);
    },
    readGoals(id) {
        return $api.get(`/business/${id}/goals`);
    },
    readUserGoals() {
        return $api.get('/goals');
    }
};
